import { t } from 'i18next'
import React from 'react'
import InputSearch from './InputSearch'
import { cn } from '../../lib/utils'
import { GridIcon, TableIcon } from '../../assets/icons/icon'

const SearchControls = ({
  searchText,
  onSearchChange,
  onSearchDebounced,
  placeholder,
  viewMode,
  onViewChange,
  totalItems,
  className,
  children
}) => {
  return (
    <div className={cn("bg-white rounded-xl shadow-card p-6 mb-6",className)}>
      <div className="flex items-center justify-between gap-4 flex-wrap md:flex-nowrap">
        {/* Search */}
        <div className="flex items-center gap-4 flex-1">
        <InputSearch searchText={searchText} placeholder={placeholder} onSearchChange={onSearchChange} onSearchDebounced={onSearchDebounced} iconClass='w-5 h-5 text-primary' />

        {/* IF ANY FILTERS */}
        {children}
        </div>

        {/* Controls */}
        <div className="flex items-center gap-3">
          <div className="flex bg-gray-100 rounded-lg p-1">
            <button
              onClick={() => onViewChange('table')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${viewMode === 'table'
                ? 'bg-white text-primary shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
                }`}
            >
              <TableIcon />
            </button>
            <button
              onClick={() => onViewChange('grid')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${viewMode === 'grid'
                ? 'bg-white text-primary shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
                }`}
            >
              <GridIcon />
            </button>
          </div>

          <div className="text-sm text-gray-500">
            {totalItems} {t('items')}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchControls


{/* <div className="flex-1 max-w-md">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <img
                className="h-5 w-5 text-gray-400"
                src={require('../../assets/images/search.svg').default}
                alt="search"
              />
            </div>
            <input
              type="text"
              value={searchText}
              onChange={(e) => {
                onSearchChange(e.target.value)
                onSearchDebounced?.(e.target.value)
              }}
              placeholder={placeholder}
              className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg
              focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all
              duration-200 text-gray-900 placeholder-gray-500"
            />
          </div>
        </div> */}